import { render, staticRenderFns } from "./RolPermisosDetails.vue?vue&type=template&id=56913ed4&scoped=true&"
import script from "./RolPermisosDetails.vue?vue&type=script&lang=js&"
export * from "./RolPermisosDetails.vue?vue&type=script&lang=js&"
import style0 from "./RolPermisosDetails.vue?vue&type=style&index=0&id=56913ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56913ed4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VLayout,VRow,VTreeview})
